import React from 'react';
import { Field } from '../Field/Field';
import i18n from '@yandex-int/i18n';
import { TextInput, Link, Label } from '@gravity-ui/uikit';
import { wrapInText } from 'client/lib/i18n-utils';
import * as keyset from 'i18n/SettingsLabels';
import clx from 'classnames';

import styles from './BrandVerification.module.scss';

const DOCUMENTATION_BRAND = 'https://webmaster.yandex.ru/sites/add/';

const t = i18n(keyset);

interface Props {
    error?: string;
    disabled: boolean;
    onChange: (updated: string) => void;
    value: string;
    brandIsVerified: boolean;
}

export const BrandVerification: React.FC<Props> = ({ error, brandIsVerified, disabled, onChange, value }) => {
    const displayError = error || (value && !brandIsVerified ? t('not-verified') : null);
    const description = wrapInText((s) => (
        <Link view="normal" href={DOCUMENTATION_BRAND} target="_blank">
            {s}
        </Link>
    ))(t('description-verification'));
    return (
        <Field fieldTitle={t('brand-verification-website')} fieldDescription={description}>
            <div className={clx(styles.formContainer, disabled && styles.formContainer_disabled)}>
                <TextInput
                    className={styles.formElement}
                    disabled={disabled}
                    onChange={(e) => onChange(e.currentTarget.value)}
                    size="xl"
                    type="url"
                    view="clear"
                    value={value}
                />
                {displayError ? <Label theme="danger">{displayError}</Label> : null}
            </div>
        </Field>
    );
};
